<template>
    <div class="index_wrap">
        <div class="part_one part banner">
            <div class="banner_content flex-between">
                <div class="banner_left">
                    <div class="banner_title">
                        <div class="banner_title_C">丰富数据资源   多样化使用方式</div>
                        <div class="banner_title_E">Rich data resources and diversified use methods</div>
                    </div>
                    <div class="data_type_list">
                        <div class="type_item" v-for="item in resourceList" :key="item.id">{{item.title}}</div>
                    </div>
                </div>
                <div class="banner_right">
                    <div v-for="item in modelList" :key="item.id" @click="$store.commit('setRouterPath',{routerPath:item.path});$router.push(item.path)" class="model_item mouse-hover">
                        <div class="vague_bg"></div>
                        <div class="model_item_content flex-column-content">
                            <div>
                                <i :class="['iconfont',item.icon]"></i>
                            </div>
                            <div>{{item.title}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="part description_info">
            <div class="des_title">系统资源</div>
            <div>针对不同背景用户提供多元化的数据资源</div>
        </div>
        <div class="part_two part flex-center">
            <div class="exp_bg flex-column-content">
                <div></div>
            </div>
            <div class="part_two_right">
                <div>
                    <div class="line_bottom"></div>
                    <div class="line_title">通用数据库</div>
                </div>
                <div class="part_two_info">基于网页交互方式查询、预览、下载使用数据。</div>
                <div class="flex-center button_wrap">
                    <div><span style="color:#00E6FF">QUERY</span>&nbsp;在线查询</div>
                    <div><span style="color:#FF9200">PREVIEW</span>&nbsp;提供预览</div>
                    <div><span style="color:#88CC03">DLOAD</span>&nbsp;下载数据</div>
                </div>
            </div>
        </div>
        <div class="part_three part ">
            <div class="description_info">
                <div class="des_title">数据接口系统</div>
                <div>基于Python数据接口程序化使用数据</div>
            </div>
            <div class="flex-center img_wrap">
                <div class="img_bg">
                    <el-carousel :interval="4000" type="card" >
                      <el-carousel-item v-for="item in imgList" :key="item.id">
                        <img :src="item.url" alt="">
                      </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
        <div class='part_four part flex-between'>
            <div class='part_two_right'>
                <div>
                    <div class='line_bottom'></div>
                    <div class='line_title'>公共数据系统</div>
                </div>
                <div class='part_two_info'>基于统计形式的行业、产业公共数据查询、下载及使用。</div>
                <div class='info_list'>
                    <div><span style='color:#FFB300'>广泛性</span>&nbsp;数据范围涵盖十二大领域</div>
                    <div><span style='color:#00FF08'>多样性</span>&nbsp;清晰展示数据简介与示例</div>
                    <div><span style='color:#00EEFF'>通用性</span>&nbsp;数据下载的方式方便快捷</div>
                </div>
            </div>
            <div class="exp_bg flex-column-content">
                <div></div>
            </div>
        </div>
        <div class="part_five part">
            <div class="sub_title">科研合作数据库</div>
            <div class="data_info">与各项高校及研究机构合作研发的特色数据资源</div>
            <div><img src="../../assets/img/exp_four.png" alt=""></div>
        </div>
        <div class="part_six part">
            <div class="sub_title">动态数据看板</div>
            <div class="data_info">以可视化图表的形式动态展示核心数据的变化趋势</div>
            <div><img src="../../assets/img/exp_three.png" alt=""></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            resourceList: [{
                id: 0,
                title: '金融数据'
            }, {
                id: 1,
                title: '财会数据'
            }, {
                id: 2,
                    title:'外汇数据'
                },{
                    id:3,
                    title:'宏观数据'
                },{
                    id:4,
                    title:'能源数据'
                },{
                    id:5,
                    title:'另类数据'
                },{
                    id:6,
                    title:'股票数据'
                },{
                    id:7,
                    title:'行业数据'
                },{
                    id:8,
                    title:'更多数据待探索...'
                }],
                modelList:[{
                    id:1,
                    title:'数据API接口',
                    icon:'icon-APIjiekouguanli',
                    path:'/dataResources'
                },{
                    id:2,
                    title:'公共数据资源',
                    icon:'icon-gonggongfuwu',
                    path:'/publicData'
                },{
                    id:3,
                    title:'特色科研合作数据',
                    icon:'icon-icon-entrust-person',
                    path:'/scientificData'
                },{
                    id:4,
                    title:'页面交互下载',
                    icon:'icon-yunxiazai',
                    path:'/commonData'
                }],
                imgList:[{
                    id:0,
                    url: require('../../assets/img/index_three_one.png')
                },{
                    id:1,
                    url: require('../../assets/img/index_three_two.png')
                },{
                    id:2,
                    url:require('../../assets/img/index_three_three.png')
                },]
            }
        },
        created(){},
        methods:{},
    }
</script>
<style lang='scss' scoped>
.part{
    padding: 0px 150px;
    box-sizing: border-box;
}
.sub_title{
    font-size: 23px;
    font-weight: bold;
    line-height: 1.7;
}
.data_info{
    margin: 15px auto 40px auto;
    font-size: 18px;
}
.part_five{
    color: #333333;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 50px
}
.part_six{
    color: white;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 50px;
    background: url('../../assets/img/part_six_bg.png') 0 0/100% 100% no-repeat;
}
.part_four{
    padding-top: 80px;
    padding-bottom: 80px;
    background: url('../../assets/img/part_four_bg.png') 0 0/100% 100% no-repeat;
    .exp_bg{
        margin-right: 150px;
        >div{
            width: 480px;
            height: 320px;
            background: url('../../assets/img/exp_two.png') 0 0/100% 100% no-repeat;
        }
    }
    .info_list{
        background: rgba(255, 255, 255, 0.20);
        backdrop-filter: blur(30px);
        font-size: 18px;
        line-height: 2.2;
        padding:  30px 120px;
    }
    .part_two_right{
        color: white;

        .line_bottom{
            border-bottom: 4px solid white;
            width: 80px;
        }
        .line_title{
            font-size: 23px;
            font-weight: bold;
            margin-top: 15px;
            letter-spacing: 2px;
        }
        .part_two_info{
            margin: 30px auto 60px 0px;
            font-size: 18px;
        }
    }
}
.part_three{
    // text-align: center;
    padding-bottom: 50px;
    .description_info{
        padding-bottom: 30px;
    }
    .img_wrap{
        width: 80%;
        margin: auto;
        .img_bg{
            width: 100%;
            min-height: 400px;
            /deep/.el-carousel__container{
                min-height: 400px;
            }
           img{
            width: 100%;
           }
        }

    }
}
.part_two{
    padding-top: 80px;
    padding-bottom: 80px;
    background: url('../../assets/img/part_two_bg.png') 0 0/100% 100% no-repeat;
    .exp_bg{
        margin-right: 150px;
        >div{
            width: 480px;
            height: 320px;
            background: url('../../assets/img/exp_one.png') 0 0/100% 100% no-repeat;
        }
    }
    .part_two_right{
        color: white;
        .button_wrap{
            >div{
                padding: 20px 30px;
                background: rgba(255,255,255,0.39);
                backdrop-filter: blur(30px);
                margin-right: 20px;
                // filter: blur(30px);
                span{
                    font-size: 20px;
                }
            }
        }
        .line_bottom{
            border-bottom: 4px solid white;
            width: 80px;
        }
        .line_title{
            font-size: 23px;
            font-weight: bold;
            margin-top: 15px;
            letter-spacing: 2px;
        }
        .part_two_info{
            margin: 40px auto 80px 0px;
            font-size: 18px;
        }
    }
}
.description_info{
    text-align: center;
    background: white;
    // width: 100vw;
    padding: 80px 0px;
    line-height: 1.7;
    font-size: 18px;
    .des_title{
        font-size: 23px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 10px;
    }
}

.part_one{
    height: 90vh;
    width: 100vw;
    background: url('../../assets/img/banner_bg.png') 0 0/100% 100% no-repeat;
    .banner_content{
        align-items: center;
        height: 90vh;
        .banner_left{
            .banner_title{
                color: white;
                .banner_title_C{
                    font-size: 45px;
                    margin-bottom: 15px;
                }
                .banner_title_E{
                    font-size: 25px;
                }
            }
            .data_type_list{
                width: 600px;
                display: flex;
                margin-top:100px ;
                flex-wrap: wrap;
                color: white;
                >div{
                    font-size: 19px;
                    margin-right: 50px;
                    margin-bottom: 30px;
                }
            }
        }
        .banner_right{
            width: 800px;
            display: flex;
            flex-wrap: wrap;
            .model_item{
                position: relative;
                width: 310px;
                height: 150px;
                margin-left: 50px;
                margin-bottom: 25px;
                border-radius: 4px;
                overflow: hidden;
                .vague_bg{
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: 2;
                    background: rgba(255, 255, 255, 0.40);
                    backdrop-filter: blur(30px);
                }
                .model_item_content{
                    z-index: 5;
                    width: 310px;
                    height: 150px;
                    position: relative;
                    justify-content: center;
                    color: white;
                    font-size: 18px;
                    i{
                        line-height: 1.7;
                        color: white;
                        font-size: 30px;
                    }
                }
            }
        }
    }
}

</style>
